export default __webpack_public_path__ + "static/skills-tag-neutral-light-a54224ac3b6c6c3a7110fa0a0f069156.png";